/**
 * Maakt van wat iemand in het linkveld typt een bruikbare href, of niets.
 *
 * Drie gevallen:
 *   - http/https/mailto  → ongewijzigd
 *   - geen schema        → https:// ervoor ("suppohrt.nl" is wat mensen typen)
 *   - ander schema       → geweigerd (null)
 *
 * Dat laatste geval is waarom dit een aparte functie is. Blind `https://`
 * voorplakken maakt van `javascript:alert(1)` de onzin-link
 * `https://javascript:alert(1)`: onschadelijk, maar de gebruiker krijgt een
 * kapotte link zonder het te weten. Weigeren is eerlijker.
 *
 * Dit is een hulpje voor de invoer, geen beveiliging: de echte grens is de
 * sanitizer aan de serverkant (backend/src/services/rich-text.sanitize.ts).
 */
export function toSafeHref(input: string): string | null {
  const url = input.trim();
  if (!url) return null;
  if (/^(https?:|mailto:)/i.test(url)) return url;
  // Iets als "ftp:" of "javascript:" — een schema dat we niet toestaan.
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return null;
  return `https://${url}`;
}
